import React from "react";
import { Box, BoxProps } from "@mui/material";

type P = {
  children: React.ReactNode;
};

const MenuBarContainer: React.FC<P> = ({ children }) => {
  return <StyledBox data-testid="menu-bar-container-box">{children}</StyledBox>;
};

export default MenuBarContainer;

export const StyledBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        "& > div": { marginRight: "50px", marginBottom: "23px" },
        "@media (max-device-width: 769px)": {
          justifyContent: "center",
          "& > div": { marginRight: "10px" }
        },
        "@media (max-device-width: 414px)": {
          "& > div": { marginRight: 0 }
        },
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
